import { type DirectiveBinding, type ObjectDirective } from "vue";

import type { CommandId } from "~/shared/enums";

type Binding = DirectiveBinding<CommandId[] | true | undefined>;

export type InputElement = HTMLElement & {
  _disabledGlobalShortcuts?: CommandId[] | true;
};

/**
 * Directive to disable certain global keyboard shortcuts in inputs.
 * Works with useKeyboardShortcuts
 */
const DisabledGlobalShortcutsDirective: ObjectDirective<InputElement, Binding["value"]> = {
  mounted(e: InputElement, binding: Binding) {
    const elem = e;
    elem._disabledGlobalShortcuts = binding.value;
  },
};

export default DisabledGlobalShortcutsDirective;
